const menu = [
  { type: 'link', label: 'Users', link: 'administration/users' },
  { type: 'divider' },
  { type: 'link', label: 'Agency', link: 'administration/agency' },
  { type: 'divider' },
  { type: 'link', label: 'Image Types', link: 'administration/image-types' },
  { type: 'divider' },
  // { type: 'link', label: 'Colors',                link: 'colors' },
];

export default menu;
